module.exports = __webpack_public_path__ + "img/GHS.67cb06a4.svg";